import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { TRANSLATIONS, Lang } from './translations';

const STORAGE_KEY = 'portal_lang';

// Norwegian is the default: the portal's actual users are Norwegian business
// contacts, not Frigg's own English-standardized staff (unlike the admin
// dashboard). See translations.ts for what is and is not covered.
const DEFAULT_LANG: Lang = 'no';

@Injectable({ providedIn: 'root' })
export class I18nService {

  lang$ = new BehaviorSubject<Lang>(this.readInitialLang());

  get lang(): Lang { return this.lang$.value; }

  setLang(lang: Lang) {
    localStorage.setItem(STORAGE_KEY, lang);
    this.lang$.next(lang);
  }

  private readInitialLang(): Lang {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'en' || stored === 'no' ? stored : DEFAULT_LANG;
  }

  // Looks up a dot-namespaced key (e.g. "shell.help") and substitutes any
  // {placeholder} tokens from `params`. Falls back to English, then to the
  // key itself, so a missing translation shows as visible mistranslated text
  // rather than throwing.
  t(key: string, params?: { [k: string]: string | number }): string {
    let value = this.lookup(TRANSLATIONS[this.lang], key);
    if (value === undefined) { value = this.lookup(TRANSLATIONS.en, key); }
    if (value === undefined) { return key; }

    if (params) {
      Object.keys(params).forEach(k => {
        value = value.replace(new RegExp('\\{' + k + '\\}', 'g'), String(params[k]));
      });
    }
    return value;
  }

  private lookup(dict: any, key: string): string | undefined {
    return key.split('.').reduce((node, part) => (node && node[part] !== undefined ? node[part] : undefined), dict);
  }
}
